<span *ngIf="goalsIds.length === 1" data-test-id="goals-bulk-delete-title">{{ "num_okrs_selected" | localize }}</span>
<span *ngIf="goalsIds.length !== 1" data-test-id="goals-bulk-delete-title">{{ "num_okrs_selected_plural" | localize : { count: goalsIds?.length || 0 } }}</span>

<button [disabled]="!goalsIds?.length" [uiDanger]="!!goalsIds?.length" (click)="delete()" ui-button data-test-id="goals-bulk-delete-action-button" uiType="primary" uiShape="round">
  {{ "delete" | localize }}
</button>
<button (click)="cancel()" ui-button data-test-id="goals-bulk-delete-cancel-button" uiType="default" uiShape="round">
  {{ "cancel" | localize }}
</button>
